import React from "react";

const FileDownload = ({
	wrapperClassName = "ride-item-download__maps",
	className = "ride-item-download__title",
	url = "",
	fileType = "",
	description = "",
	xlinkHref = "",
	fileSize = false,
	onClick = null
}) =>
	url ? (
		<div className={ wrapperClassName }>
			<div className={ className }>
				<svg
					className={ `icon icon--${ fileType.toLowerCase() }` }
					aria-hidden="true"
				>
					<use xlinkHref={ xlinkHref } />
				</svg>
				<a
					href={ url }
					download
					onClick={ () => onClick && onClick() }
				>
					Download { fileType }{ " " }
					{ fileSize && <small style={ { fontSize: ".7em" } }>({ fileSize })</small> }
				</a>
			</div>
			<p>{ description }</p>
		</div>
	) : null;

export default FileDownload;



// WEBPACK FOOTER //
// ./src/components/FileDownload.js